"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var get_css_1 = __importDefault(require("../get-css"));

var regex_1 = require("../utils/regex");

exports.propTypes = {
  borderBottomLeftRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  borderBottomRightRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  borderRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  borderTopLeftRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
  borderTopRightRadius: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {
  borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius']
};
exports.propValidators = {};

if (process.env.NODE_ENV !== 'production') {
  exports.propValidators.borderRadius = function (value) {
    if (regex_1.spacesOutsideParentheses.test(value)) {
      return "multiple values (\u201C".concat(value, "\u201D) aren\u055At supported with \u201CborderRadius\u201D. Use \u201CborderBottomLeftRadius\u201D, \u201CborderBottomRightRadius\u201D \u201CborderTopLeftRadius\u201D and \u201CborderTopRightRadius\u201D instead.");
    }

    return;
  };
}

var _borderTopLeftRadius = {
  className: 'btlr',
  cssName: 'border-top-left-radius',
  jsName: 'borderTopLeftRadius'
};
var _borderTopRightRadius = {
  className: 'btrr',
  cssName: 'border-top-right-radius',
  jsName: 'borderTopRightRadius'
};
var _borderBottomLeftRadius = {
  className: 'bblr',
  cssName: 'border-bottom-left-radius',
  jsName: 'borderBottomLeftRadius'
};
var _borderBottomRightRadius = {
  className: 'bbrr',
  cssName: 'border-bottom-right-radius',
  jsName: 'borderBottomRightRadius'
};
exports.propEnhancers = {
  borderBottomLeftRadius: function borderBottomLeftRadius(value) {
    return get_css_1.default(_borderBottomLeftRadius, value);
  },
  borderBottomRightRadius: function borderBottomRightRadius(value) {
    return get_css_1.default(_borderBottomRightRadius, value);
  },
  borderTopLeftRadius: function borderTopLeftRadius(value) {
    return get_css_1.default(_borderTopLeftRadius, value);
  },
  borderTopRightRadius: function borderTopRightRadius(value) {
    return get_css_1.default(_borderTopRightRadius, value);
  }
};